import {queryOrgCompanyList} from "@api/core/org";

// 按模块的action, reducer整合体
const COMPANY_LIST = 'COMPANY_LIST';

export function getCompanyList() {
  return (dispatch, getState) => {
    const { company_list: list } = getState();
    if (list.length > 0) {
      return dispatch({
        type: COMPANY_LIST,
        data: list,
      });
    }
    return queryOrgCompanyList({
      type: 1,
    }).then(res => {
      if (res.statusCode === 200) {
        return dispatch({
          type: COMPANY_LIST,
          data: res.data,
        });
      }
    });
  };
}

export function companyList(state = [], action) {
  switch (action.type) {
    case COMPANY_LIST:
      return action.data;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/company_list.js